import { ACTION_TYPE, GETTER_TYPE, MUTATION_TYPE } from './types'

export default {
  state: {
    toasts: [],
    count: 0
  },
  mutations: {
    [MUTATION_TYPE.pushToasts]: (state, toasts) => {
      state.toasts.push(toasts)
    },
    [MUTATION_TYPE.spliceToast]: (state, id) => {
      state.toasts = state.toasts.filter((p) => p.id !== id)
    },
    [MUTATION_TYPE.incCount]: (state) => {
      state.count += 1
    }
  },
  actions: {
    [ACTION_TYPE.pushToasts]: ({ commit, getters }, toasts) => new Promise((resolve) => {
      toasts.id = getters.getCount
      commit(MUTATION_TYPE.incCount)
      commit(MUTATION_TYPE.pushToasts, toasts)
      resolve()
    }),
    [ACTION_TYPE.delToast]: ({ commit }, id) => new Promise((resolve) => {
      commit(MUTATION_TYPE.spliceToast, id)
      resolve()
    })
  },
  getters: {
    [GETTER_TYPE.getToasts]: (state) => state.toasts,
    [GETTER_TYPE.getCount]: (state) => state.count
  }
}
